import sidebar from './sidebar'
import noticeCenter from './notice-center'
import user from './user'
import menus from './menus'
import layoutStore from '../views/layoutDetail/layoutStore'

export default {
    namespaced: true,
    modules: {
        sidebar,
        noticeCenter,
        user,
        menus,
        layoutStore
    },
    state: {
        attachmentId: '',
        homepage: '',
        modulesIsLoaded: false,
        tenant: {},
        pageCatch: false,
        WS: null,
        iframe: {
            actived: false,
            src: '',
            data: null
        }
    },
    mutations: {
        //监控头像图片变化
        setAttachmentId(state, payload) {
            state.attachmentId = payload
        },
        // 设置WS连接
        setWS(state, ws) {
            state.WS = ws
        },
        setModulesCompleted(state) {
            state.modulesIsLoaded = true
        },
        // 设置菜单状态
        setMenuItemState(state, menuData) {
            let findByParams = (params, menus, parent) => {
                for (let i = 0; i < menus.length; i++) {
                    let item = menus[i]
                    if (item.params) {
                        let itemParams = item.name + item.params.objectId
                        if (params === itemParams) {
                            item.meta.actived = true
                            if (parent) {
                                parent.active = true
                                let parentParams = parent.name + parent.params.objectId
                                findByParams(parentParams, state.menus)
                            }
                            break
                        } else if (item.children) {
                            findByParams(params, item.children, item)
                        }
                    } else {
                        continue
                    }
                }
            }
            let findByName = (name, menus, parent) => {
                for (let i = 0; i < menus.length; i++) {
                    let item = menus[i]
                    if (item.name === name) {
                        item.meta.actived = true
                        if (parent) {
                            item.meta.actived = true
                            findByName(parent.name, state.menus)
                        }
                        break
                    } else if (item.children) {
                        findByName(name, item.children, item)
                    }
                }
            }
            if (
                menuData.name.indexOf('obj_') > -1 ||
                menuData.name === 'customObjectList' ||
                menuData.name === 'customObjectHandle'
            ) {
                const params = menuData.name + menuData.params.objectId
                findByParams(params, state.menus)
            } else {
                findByName(menuData.name, state.menus)
            }
        },
        // 重置激活状态
        resetMenus(state) {
            let doIt = menus => {
                for (let i = 0; i < menus.length; i++) {
                    let item = menus[i]
                    if (item.meta.actived) {
                        item.meta.actived = false
                        if (item.children && item.children.length > 0) {
                            doIt(item.children)
                        }
                    } else {
                        continue
                    }
                }
            }
            doIt(state.menus)
        },
        // 设置租户信息
        setTenant(state, data) {
            state.tenant = data
        },
        // 设置缓存页面
        setPageCatch(state) {
            state.pageCatch = true
        },
        // 去除页面缓存
        removePageCatch(state) {
            state.pageCatch = false
        },
        // 设置iframe数据
        setIframe(state, payload) {
            state.iframe = {...state.iframe, ...payload }
        }
    }
}